import Vue from 'vue';
import Router from 'vue-router';
const EnterpriseIdentityVerification = () => import("../components/EnterpriseIdentityVerification.vue");
const App = () => import('@/App.vue');

Vue.use(Router);

function checkTemporaryId(tempId) {
    if (tempId && sessionStorage.getItem(tempId) === "valid") {
        sessionStorage.removeItem(tempId);
        return true;
    }
    return false;
}

function processOAuthCallback(code) {
    return new Promise((resolve, reject) => {
        setTimeout(() => {
            if (code) {
                resolve();
            } else {
                reject("Invalid code");
            }
        }, 1000);
    });
}

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: "/",
            name: "home",
            alias: "/",
            component: App
        },
        {
            path: '/callback',
            name: 'callback',
            beforeEnter: (to, from, next) => {
                const code = to.query.code;
                const state = to.query.state || '/';

                if (code) {
                    processOAuthCallback(code)
                        .then(() => {
                            next({ path: state, query: {} });
                        })
                        .catch(() => {
                            next({ name: 'home' });
                        });
                } else {
                    next({ name: 'home' });
                }
            },
        },
        {
            path: '/employee-identity-verification/:tempId',
            name: 'employee-identity-verification',
            component: EnterpriseIdentityVerification,
            beforeEnter: (to, from, next) => {
                const isValid = checkTemporaryId(to.params.tempId);
                if (isValid) {
                    next();
                } else {
                    next({ name: 'home' });
                }
            }
        }
    ]
});

router.beforeEach((to, from, next) => {
    if (to.path === from.path) {
        next(false);
    } else {
        next();
    }
});

export default router;